import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
     
<footer className="main-footer-section">
    <div className="contact-details">
        <div className="container px-5">
            <div className="row g-0">
                <div className="col-lg-4 ">
                    <div className="contact-div d-flex flex-column justify-content-center align-items-center">
                        <div className="icon-div d-flex justify-content-center align-items-center rounded-circle mb-3">
                            

                        </div>
                        
                    </div>
                </div>

                <div className="col-lg-4 ">
                    <div className="contact-div d-flex flex-column justify-content-center align-items-center">
                        <div className="icon-div d-flex justify-content-center align-items-center rounded-circle mb-3">
                            
                            
                        </div>
                        
                    </div>
                </div>

                <div className="col-lg-4 ">
                    <div className="contact-div d-flex flex-column justify-content-center align-items-center">
                        <div className="icon-div d-flex justify-content-center align-items-center rounded-circle mb-3">
                            
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <div className="footer-section text-white">
            <div className="container">
                <div className="row">
                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-links">
                            <h4 className="text-black mt-5 mb-3">
                            <NavLink to="/lostandfound" className="btn btn-primary text-nowrap d-block">
                            Lost Item                       </NavLink></h4>
                            <NavLink to="/" className="btn btn-primary d-block">
                               Home                     </NavLink>
                                
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-links">
                            <h4 className="text-black mt-5 mb-3">
                            <NavLink to="/transport" className="btn btn-primary d-block">
                            Transport                       </NavLink> 
                            </h4>
                            <NavLink to="/about" className="btn btn-primary d-block">
                            About Us                       </NavLink>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-links">
                            <h4 className="text-black mt-5 mb-3"><NavLink to="/airlines" className="btn btn-primary d-block">
                            Airlines                       </NavLink></h4>
                            <NavLink to="/contact" className="btn btn-primary d-block">
                            Contact                       </NavLink>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-links">
                            <h4 className="text-black mt-5 mb-3"><NavLink to="/faq" className="btn btn-primary d-block">
                            FAQ                       </NavLink></h4>
                            <NavLink to="/lounge" className="btn btn-primary d-block">
                            Lounge                       </NavLink>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-links">
                            <h4 className="text-black mt-5 mb-3"><NavLink to="/parking" className="btn btn-primary d-block">
                            Parking                      </NavLink></h4>
                            <NavLink to="/restaurant" className="btn btn-primary d-block">
                            Restaurant                       </NavLink>
                        </div>
                    </div>
                   

                    
                </div>
            </div>
        </div>


        <div className="container">
            <hr className="container mx-auto"/>

            <div className="row">
                <div className="col-lg-8 col-12 footer-text">
                    Copyright ©2023 All rights reserved. <br/><strong> Official website of  MAHARAJA BIR BIKRAM AIRPORT, AGARTALA</strong>
                </div>
                   
            </div>
        </div>
    </div>
</footer>
    </>
  );
};

export default Footer;
